import React from 'react';
import {Pie} from 'react-chartjs-2';




export default ({item}) => {
  const options = { maintainAspectRatio: false };
  const data = {
    labels: [
      'Man',
      'Kvinna'
    ],
    datasets: [{
      data: [item.gendermale, item.genderfemale ],
      backgroundColor: ["#0288d1",  "#90C2E7","#092327","#0B5351", "#4E8098"],
    }]
  };

  return ( 
  <Pie width={250} height={250} options={options}  data={data} />
  );
}





// WEBPACK FOOTER //
// ./src/components/Charts/ChartTargetGender.jsx